import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Accounts não tem engrenagem: general settings fica no menu lateral.
const NavbarTop = ({ title, onHomeClick }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="accounts"
    onHomeClick={onHomeClick}
    zIndexClass="z-50"
  />
);

export default NavbarTop;
